import { useState, useEffect, useRef } from "react"
import { router } from "@inertiajs/react"

export function useDebouncedSearch(initialValue: string, url: string, paramName: string, delay = 300) {
  const [value, setValue] = useState(initialValue)
  const inputRef = useRef<HTMLInputElement>(null)
  const isFirstRender = useRef(true)
  const hasSearched = useRef(false)

  useEffect(() => {
    inputRef.current?.focus()
  }, [])

  useEffect(() => {
    if (isFirstRender.current) {
      isFirstRender.current = false
      return
    }

    const timeout = setTimeout(() => {
      if (value.length >= 2) {
        hasSearched.current = true
        router.get(url, { q: { [paramName]: value } }, { preserveState: true })
      } else if (value === "" && hasSearched.current) {
        hasSearched.current = false
        router.get(url, { q: { [paramName]: value } }, { preserveState: true })
      }
    }, delay)

    return () => clearTimeout(timeout)
  }, [value, url, paramName, delay])

  return [value, setValue, inputRef] as const
}
